import task from './service/task';
import popup from "./Common/popup";
import StaffData from "./StaffData";
import UserReducer from "./UsersData";
import { combineReducers } from 'redux';
import service from './service/service';
import loading from './service/loading';
import taskDetails from './service/taskDetails';
import ProductReducer from "./Common/ProductReducer";
import CommandsReducer from './Common/CommandsReducer';
import locationDataReducer from './location/locationData';
import customerDataReducer from './customer/CustomerData';
import happycallDataReducer from "./service/HappyCallData";
import SystemSettingsReducer from './Common/SystemSettings';
import guaranteeCardsReducer from './guaranteeCards/GuaranteeCardsData';
import ProductRequestReducer from "./ProductRequest/ProductRequestForService";
import SMSReducer from "./SMSReducer";


const reducers = combineReducers({
  
  task,
  popup,
  loading,
  service,
  StaffData,
  SMSReducer,
  taskDetails,
  UserReducer,
  ProductReducer,
  CommandsReducer,  
  customerDataReducer,
  locationDataReducer,
  happycallDataReducer,
  ProductRequestReducer,
  guaranteeCardsReducer,
  SystemSettingsReducer
  
})


export default reducers;